export enum ArrowType {
    LPtoAtom = "pa",
    LPtoBond = "pb",
    BondToAtom = "ba",
    BondToBond = "bb",
    RtoAtom = "ra",
    RtoBond = "rb",
    CBondToAtom = "cba",
    CBondToBond = "cbb",
    Unknown = "unknown",
}

/*
* rad to atom
* src: atom id, dst: atom id
*
* rad to bond
* src: atom id, dst: bond id
*
* c bond to atom
* src: bond id, dst: atom id
*
* c bond to bond:
* src: bond id, dst: bond id
* */